import script from "./Cards.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cards.vue?vue&type=script&setup=true&lang=ts"

import "./Cards.vue?vue&type=style&index=0&id=e4ae3e56&lang=css"

const __exports__ = script;

export default __exports__